/**
 * The number part of a request that issues a document.
 *
 * Numbering is automatic: `invoiceNumber: null` asks the server to assign the
 * next number of the document's series at the moment it is issued. Only when
 * the operator ticks "indica il numero a mano" does a number travel — trimmed,
 * and still checked by the server against its series.
 */
export function numberingPayload({ manual, invoiceNumber }) {
  return { invoiceNumber: manual ? String(invoiceNumber ?? '').trim() : null };
}

/** Whether the number part allows submitting: always when automatic. */
export function numberingReady({ manual, invoiceNumber }) {
  return !manual || String(invoiceNumber ?? '').trim() !== '';
}
